// @flow

import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import type { State } from 'types/redux';
import type { Props } from './PanelDropOff';
import { injectIntl } from 'react-intl';

// Components
import PanelDropOff from './PanelDropOff';

// Actions
import {
  setTransportationOption,
  sendTransportationOptionsStart
} from 'store/reducers/appointment/actions';
// Selectors
import {
  transportWithoutValet,
  isTransportationAvailable
} from 'store/reducers/apptOptions/selectors';
import {
  amenities,
  getDealerName
} from 'store/reducers/dealerSettings/selectors';
import {
  getTransportation,
  getTranspOptionInfo
} from 'store/reducers/appointment/selectors';
import { getTranslate } from 'store/reducers/localizationString/selectors';

const mapStateToProps = (state: State): $Shape<Props> => ({
  transportOptions: transportWithoutValet(state),
  amenities: amenities(state),
  transportation: getTransportation(state),
  transpOptionInfo: getTranspOptionInfo(state),
  dealerName: getDealerName(state),
  isTransportationAvailable: isTransportationAvailable(state),
  getTranslate: getTranslate(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    { setTransportationOption, sendTransportationOptionsStart }
  )
)(PanelDropOff);



// WEBPACK FOOTER //
// ./src/components/molecules/PanelDropOff/PanelDropOffContainer.js